import { useApi } from '@/api';
import { TableSkeleton, Link } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import {
  CryptoIcon,
  Flex,
  useTableProps,
  CurrencyValue,
  DataTable,
  RelativeDateTime,
  Box
} from '@blockanalitica/ui';

export default function LiquidationsTable() {
  const { pagination, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-debt',
    filtersDebounceTime: 50
  });
  const [data, error] = useApi({
    url: '/liquidations/',
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Vault type',
        getCell: (row) => (
          <Flex alignItems="center" gap="2xs">
            <CryptoIcon
              name={row.symbol}
              address={row.collateral_address}
              size="1"
            />
            <Flex flexDirection="column" gap="3xs">
              {row.ilk}
            </Flex>
          </Flex>
        ),
        columnSize: ['minmax(100px, auto)']
      },
      {
        header: 'Vault',
        getCell: (row) => row.cdp,
        columnSize: ['minmax(110px, auto)', 'minmax(150px, auto)'],
        sortingField: 'cdp'
      },
      {
        header: 'Collateral seized',
        getCell: (row) => (
          <CurrencyValue
            value={row.collateral_seized}
            options={{
              currency: {
                name: row.symbol,
                address: row.collateral_address
              },
              iconSize: '0'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'collateral_seized'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Debt Repaid
            <CryptoIcon name="DAI" size="0" />
          </Flex>
        ),
        getCell: (row) => <CurrencyValue value={row.debt_repaid} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'debt_repaid'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Penalty
            <CryptoIcon name="DAI" size="0" />
          </Flex>
        ),
        getCell: (row) => <CurrencyValue value={row.penalty} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'penalty'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Box color="muted">
            {row.auction_end ? (
              <RelativeDateTime value={row.auction_end} />
            ) : (
              '–'
            )}
          </Box>
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'auction_end'
      }
    ];
    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.auction_id + row.ilk + row.urn}
        rowLinkProps={{
          to: (row) => `${row.ilk}/${row.auction_id}`,
          // @ts-ignore
          linkComponent: Link
        }}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton rows={pagination.pageSize} />;
}
